var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7823 7.81291C30.6997 10.7301 30.6997 15.4599 27.7823 18.3771C24.8652 21.2944 20.1354 21.2944 17.2182 18.3771C14.301 15.4599 14.301 10.7301 17.2182 7.81291C20.1354 4.8957 24.8652 4.8957 27.7823 7.81291Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 26.2651C31.0387 26.2651 39.375 29.9533 39.375 35.6251V37.5001C39.375 38.5351 38.535 39.3751 37.5 39.3751H7.5C6.465 39.3751 5.625 38.5351 5.625 37.5001V35.6251C5.625 29.9514 13.9613 26.2651 22.5 26.2651Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationGuests);
export default __webpack_public_path__ + "static/media/navigation-guests.85d70fd9.svg";
export { ForwardRef as ReactComponent };